import {
  Component,
  ElementRef,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  ViewChild,
  ChangeDetectorRef,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgForOf, NgIf } from '@angular/common';
import { MarkdownComponent, provideMarkdown } from 'ngx-markdown';

import { ButtonModule } from 'primeng/button';
import { DropdownModule } from 'primeng/dropdown';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { AvatarModule } from 'primeng/avatar';

import { SocketService } from '@admin/ai/ai-chat/ai-live-chat/socket.service';
import { AiService } from '@admin/shared/services/ai.service';

import { AiAskComponent } from '../ai-ask/ai-ask.component';
interface City {
  name: string;
  code: string;
}
@Component({
  selector: 'app-ai-live-chat',
  imports: [
    AiAskComponent,
    ButtonModule,
    DropdownModule,
    FormsModule,
    ScrollPanelModule,
    NgForOf,
    NgIf,
    AvatarModule,
    MarkdownComponent,
  ],
  templateUrl: './ai-live-chat.component.html',
  styleUrl: './ai-live-chat.component.scss',
  standalone: true,
  providers: [provideMarkdown()],
})
export class AiLiveChatComponent implements OnInit, OnChanges, OnDestroy {
  @ViewChild('scrollPanelRef') scrollPanelRef!: ElementRef;

  @Input() currentWorkspace: any;
  chatPathRegex = /^\/c\/(.*)$/;
  messages: any = [];
  currentChatId: string | null = null;

  private routeSub: any;
  private newMessageSub: any;
  private chatResponseSub: any;

  aiBots: City[] | undefined;
  selectedAiBot: City | undefined;
  private latestChatId: string | null = null;
  prompts = [
    {
      title: 'Viral Content Creator',
      description: 'Generate high-engagement social media posts tailored to your audience.',
    },
    {
      title: 'Engagement Booster',
      description: 'Craft engaging replies and captions to maximize interaction.',
    },
    {
      title: 'Hashtag Strategist',
      description: 'Find the best hashtags to reach a larger audience.',
    },
    {
      title: 'Ad Copy Specialist',
      description: 'Create compelling ad copies that convert clicks into customers.',
    },
    {
      title: 'Trending Topic Finder',
      description: 'Discover trending topics in your niche to stay ahead.',
    },
    {
      title: 'Social Media Storyteller',
      description: 'Write captivating stories for Instagram, Facebook, and TikTok.',
    },
    {
      title: 'Influencer Collaboration Finder',
      description: 'Get suggestions for influencers to collaborate with.',
    },
    {
      title: 'Post Scheduling Advisor',
      description: 'Find the best times to post for maximum reach.',
    },
    {
      title: 'Reel & TikTok Script Writer',
      description: 'Generate engaging scripts for short-form videos.',
    },
    {
      title: 'Customer Response Optimizer',
      description: 'Craft perfect responses to boost engagement and sales.',
    },
  ];
  displayedPrompts: any = [];
  constructor(
    private socketService: SocketService,
    private aiService: AiService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private cdr: ChangeDetectorRef
  ) {
    this.aiBots = [
      { name: 'ChatGPT', code: 'CG' },
      { name: 'ChatGPT', code: 'C2' },
    ];
    this.shufflePrompts();
  }

  ngOnInit() {
    this.socketService.initializeSocket(); // Ensure socket is initialized
    // this.trackChatIdChanges();
    this.newMessageSocket();
    this.readChatResponse();
  }

  /*  trackChatIdChanges() {
    this.routeSub = this.activatedRoute.params.subscribe((params) => {
      this.currentChatId = params['id'] || null;
      if (this.currentChatId) {
        this.getAllMessagesOfChatId();
      }
    });
  }*/

  newMessageSocket() {
    this.newMessageSub = this.socketService.receiveEvent('newMessage').subscribe((data) => {
      this.currentChatId = data.chatID;
      // if (data.chatID === this.currentChatId) {
      if (this.messages.length > 0) {
        if (this.messages[this.messages.length - 1].role === 'assistant') {
          if (data.content) {
            this.messages = [...this.messages, { role: 'user', content: data.content.content }];
          }
        }
      } else {
        if (data.content) {
          this.messages = [
            ...this.messages,
            { role: data.content.role, content: data.content.content },
          ];
        }
      }
      this.cdr.detectChanges();
      //    }
    });
  }

  readChatResponse() {
    this.chatResponseSub = this.socketService
      .receiveEvent('chatgptResChunk')
      .subscribe((data: any) => {
        if (data.chatID === this.currentChatId) {
          if (this.messages[this.messages.length - 1]?.role === 'user') {
            this.messages = [...this.messages, { role: 'assistant', content: data.content }];
          }
          this.messages = [
            ...this.messages.slice(0, -1),
            { role: 'assistant', content: data.content },
          ];
          this.scrollToBottom();
          this.cdr.detectChanges();
        }
      });
  }

  ngOnChanges() {
    /*if (changes['currentWorkspace']) {
      this.getAllMessagesOfChatId();
    }*/
  }

  ngOnDestroy(): void {
    this.socketService.disconnect();
    if (this.routeSub) this.routeSub.unsubscribe();
    if (this.newMessageSub) this.newMessageSub.unsubscribe();
    if (this.chatResponseSub) this.chatResponseSub.unsubscribe();
  }

  /*getAllMessagesOfChatId() {
    if (this.currentChatId && this.currentWorkspace) {
      this.aiService
        .getMessagesByConversationID(
          this.currentWorkspace.uuid,
          this.activatedRoute.snapshot.params['id']
        )
        .subscribe((result: any) => {
          this.messages = result.reverse();
          this.scrollToBottom();
        });
    }
  }*/

  /* updateUrlWithString(receivedString: string): void {
    this.router.navigate(['ai', 'ai-chat', receivedString]);
  }*/

  sendMessage(userInput: any): void {
    if (!this.latestChatId) {
      this.socketService
        .sendEvent('newChat', {
          message: { role: 'user', content: userInput },
          chatID: '',
        })
        .subscribe((res) => {
          // dont update for new chats, when click on history then only create
          // set it in somehwere subject or somwhere else
          this.latestChatId = res.chatID;
          //  this.updateUrlWithString(res.chatID);
        });
    } else {
      this.socketService
        .sendEvent('newChat', {
          message: { role: 'user', content: userInput },
          chatID: this.latestChatId,
        })
        .subscribe();
    }
  }

  scrollToBottom(): void {
    if (this.scrollPanelRef && this.scrollPanelRef.nativeElement) {
      const scrollable = this.scrollPanelRef.nativeElement;
      scrollable.scrollTop = scrollable.scrollHeight;
    }
  }

  shufflePrompts() {
    // Shuffle and pick the first 4 prompts to display
    this.displayedPrompts = this.prompts.sort(() => Math.random() - 0.5).slice(0, 4);
  }
}
